module.exports = __webpack_public_path__ + "assets/img/help_closebtn_sp.8810f126.svg";